import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'

export interface BreakTemplateInterface {
  message: string
  messageEn?: string
  color?: string
  status: string
}

export interface IFBreakTemplate {
  breakTemplateId: number
  message: string
  messageEn: string
  color: string
  isDefault: number
  status: string
  updatedBy: string
  updatedAt: string
  createdBy: string
  createdAt: string
}

export default class BreakTemplateApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get('break-templates', { params: { ...props } }).then((res) => res)
  }

  static create(payload: BreakTemplateInterface) {
    return this.api.post('break-templates', payload)
  }

  static findById(id: number): Promise<IFBreakTemplate> {
    return this.api.get(`break-templates/${id}`)
  }

  static update(id: number, body: BreakTemplateInterface) {
    return this.api.patch(`break-templates/${id}`, body)
  }

  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`break-templates/${id}/status`, { id, status })
  }

  static checkUsage(id: number): Promise<any> {
    return this.api.get(`break-templates/${id}/usage`)
  }

  static remove(id: number) {
    return this.api.delete(`break-templates/${id}`)
  }
}
